<div class="cdk-virtual-scroll-topcontent-wrapper">
    <!-- Select headerTable -->
    <ng-content select="[id=headerTable]"></ng-content>
</div>
<div #contentWrapper class="cdk-virtual-scroll-content-wrapper">
    <ng-content></ng-content>
</div>
<div class="cdk-virtual-scroll-spacer" [style.width]="_totalContentWidth" [style.height]="_totalContentHeight"></div>
